<template>
    <div class="invitaciones-section">
        <div class="invitaciones-content">
            <h2 class="invitaciones-title fuente-posm">Invitaciones Personalizadas</h2>
            <p class="invitaciones-text fuente-nova">
                Vende más con conexiones directas con tus clientes, basadas en sus preferencias y hábitos de consumo.
                <br><br>
                Crea invitaciones VIP para tus mejores clientes y envíalas directo por WhatsApp. Genera listas
                optimizadas para tus campañas de redes sociales.
            </p>
        </div>
        <div class="invitaciones-video">
            <video controls :poster="posterUrl">
                <source :src="videoUrl" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InvitacionesPersonalizadasNew',
    data() {
        return {
            posterUrl: require('@/assets/images/a41.webp'),
            videoUrl: require('@/assets/images/F.mp4')
        }
    }
}
</script>

<style lang="css" scoped>
.invitaciones-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 60px;
    background-color: var(--color-2);
}

.invitaciones-content {
    flex: 1;
    max-width: 600px;
}

.invitaciones-title {
    color: var(--color-5);
    font-size: 70px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.invitaciones-text {
    color: var(--color-5);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.invitaciones-video {
    flex: 0 0 auto;
    max-width: 500px;
}

.invitaciones-video video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .invitaciones-title {
        font-size: 60px;
    }

    .invitaciones-text {
        font-size: 27px;
    }

    .invitaciones-video {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .invitaciones-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 0;
    }

    .invitaciones-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .invitaciones-video {
        order: 2;
        width: 100%;
        max-width: none;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }

    .invitaciones-video video {
        width: 90%;
        max-width: none;
    }

    .invitaciones-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .invitaciones-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
